import helper from '../../helper';

export const getUrl = (url, corporateInformation, productDepartment, classNumber, itemId) => {
/* eslint-disable camelcase */
  let cm_mmc;
  let urlPath = url;
  if (corporateInformation?.fiscalYear) {
    cm_mmc = `socialmedia|O|FY${helper.getFiscalYear(corporateInformation)}|NA|PIN|${productDepartment}|${classNumber}|PIPsave|${itemId}|`; // eslint-disable-line max-len
  }
  if (/cm_mmc=/.test(urlPath)) {
    urlPath = urlPath.replace(/cm_mmc=([^&]+)/, cm_mmc);
  } else if (urlPath.indexOf('?') !== -1) {
    urlPath += '&cm_mmc=' + cm_mmc;
  } else {
    urlPath += '?cm_mmc=' + cm_mmc;
  }
  return urlPath;
};

const FISCAL_YEAR_RULES = {
  2018: { fiscalYear: '18' },

  2019: { cutoff: { month: 2, day: 3 }, prev: '18', curr: '19' },
  2020: { cutoff: { month: 2, day: 2 }, prev: '19', curr: '20' },

  // normalized (previously mm === 1)
  2021: { cutoff: { month: 1, day: 31 }, prev: '20', curr: '21' },

  2022: { cutoff: { month: 1, day: 30 }, prev: '21', curr: '22' },
  2023: { cutoff: { month: 1, day: 29 }, prev: '22', curr: '23' },
  2024: { cutoff: { month: 1, day: 28 }, prev: '23', curr: '24' }
};

export function calcFiscalYear(today) {
  const year = today.getFullYear();
  const rule = FISCAL_YEAR_RULES[year];

  // default fallback
  if (!rule) {
    return '24';
  }

  // simple case (2018)
  if (!rule.cutoff) {
    return rule.fiscalYear;
  }

  const month = today.getMonth() + 1;
  const day = today.getDate();

  const { month: cutoffMonth, day: cutoffDay } = rule.cutoff;

  const isBeforeOrOnCutoff = month < cutoffMonth
    || (month === cutoffMonth && day <= cutoffDay);

  return isBeforeOrOnCutoff ? rule.prev : rule.curr;
}

export const generatePinCode = (collectionId) => {
  let url = '?cm_mmc=socialmedia|O|FY{fiscal_year}|NA|PIN|Multi|Multi|SpaceCollectionsave|coll_{collection_id}';
  let today = new Date();
  url = url.replace('{fiscal_year}', calcFiscalYear(today));
  url = url.replace('{collection_id}', collectionId);
  return url;
};
